import {
  FormFieldSection,
  FormFields,
} from 'app/modules/filingFormGenerator/models';
import {
  dateField,
  selectField,
  textField,
  textareaField,
} from 'app/modules/goAML/formConfig/fields/fieldBuilders';
import { GoamlReferenceTables } from 'app/modules/goAML/queries/useGetGoamlFiuConfig';

type FieldValues = Record<string, any>;

const getCoreFields = (
  referenceTables: GoamlReferenceTables,
): FormFields<FieldValues> => [
  selectField(
    { name: 'gender', label: 'Gender', refTable: 'gender' },
    referenceTables,
  ),
  textField({ name: 'title', label: 'Title' }),
  textField({ name: 'first_name', label: 'First name', required: true }),
  textField({ name: 'middle_name', label: 'Middle name' }),
  textField({ name: 'last_name', label: 'Last name', required: true }),
  dateField({ name: 'birthdate', label: 'Birth date' }),
  textField({ name: 'birth_place', label: 'Birth place' }),
  textField({ name: 'ssn', label: 'SSN' }),
  textField({ name: 'passport_number', label: 'Passport number' }),
  selectField(
    {
      name: 'passport_country',
      label: 'Passport country',
      refTable: 'country_code',
    },
    referenceTables,
  ),
  textField({ name: 'id_number', label: 'ID number' }),
  selectField(
    { name: 'nationality1', label: 'Nationality 1', refTable: 'country_code' },
    referenceTables,
  ),
  selectField(
    { name: 'nationality2', label: 'Nationality 2', refTable: 'country_code' },
    referenceTables,
  ),
  selectField(
    { name: 'nationality3', label: 'Nationality 3', refTable: 'country_code' },
    referenceTables,
  ),
  selectField(
    { name: 'residence', label: 'Residence', refTable: 'country_code' },
    referenceTables,
  ),
  textField({ name: 'email', label: 'Email' }),
  textField({ name: 'occupation', label: 'Occupation' }),
  textField({ name: 'employer_name', label: 'Employer name' }),
];

const OPTIONAL_FIELDS: FormFields<FieldValues> = [
  textField({ name: 'mothers_name', label: "Mother's name" }),
  textField({ name: 'alias', label: 'Alias' }),
  selectField({
    name: 'deceased',
    label: 'Deceased?',
    options: [
      { value: '0', text: 'No' },
      { value: '1', text: 'Yes' },
    ],
  }),
  dateField({ name: 'date_deceased', label: 'Date deceased' }),
  textField({ name: 'tax_number', label: 'Tax number' }),
  textField({ name: 'tax_reg_number', label: 'Tax registration number' }),
  textField({ name: 'source_of_wealth', label: 'Source of wealth' }),
  textareaField({ name: 'comments', label: 'Comments' }),
];

export const getReportingPersonFields = (
  referenceTables: GoamlReferenceTables,
): FormFields<FieldValues> => {
  const optionalSection: FormFieldSection<FieldValues> = {
    type: 'section',
    name: 'additional_details',
    label: 'Additional details',
    collapsible: true,
    defaultCollapsed: true,
    bindFieldsToParentPath: true,
    mustExistInPayload: false,
    mustHaveValueIfExist: false,
    fields: OPTIONAL_FIELDS,
  };

  return [...getCoreFields(referenceTables), optionalSection];
};
